<div class="banner d-lg-block d-none"></div>

<h1 class="accessibility-only">Badges</h1>
<div class="container mt-4">
  <fgbcl-badge-achieved />
</div>

<fgbcl-scorecard-list-view
  [isSponsorInBody]="false"
  [icon]="'chevron_right'"
  [showPlaceholder]="true"
></fgbcl-scorecard-list-view>

<!--Scorecard carousel-->
<fgbcl-scorecard-carousel [isSponsorInBody]="false" [icon]="'chevron_right'"></fgbcl-scorecard-carousel>

<div class="container mt-4">
  <fgbcl-badge-overview-list [showPlaceholder]="true"></fgbcl-badge-overview-list>
</div>
